import React from 'react';
import { PropTypes as PT } from 'prop-types';
import _compact from 'lodash/compact';
import CallView from './CallViewHolder';
import Portal from 'components/MiniPlayer/Portal';
import Popout from 'components/Popout/Popout';
import Drawer from 'containers/InCall/InCallDrawer/InCallDrawerContainer';
import MiniPlayerContainer from 'containers/MiniPlayerContainer';
import classes from './InCallView.module.scss';

/**
 * This View is the top order component for in call view. It holds the left side
 * CallView (header, video, and footer elements) and the Drawer (in call state
 * information, moderator controls, chat, etc...)
 * @param {bool} props isVisible whether to display the video or not.
 */

class InCallView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCall: false,
        counter: 0,
      showWindowPortal: false
    };
    this.toggleWindowPortal = this.toggleWindowPortal.bind(this);
  }

  componentDidMount() {
    window.setInterval(() => {
      this.setState(state => ({
        ...state,
        counter: state.counter + 1,
      }));
    }, 1000);
  }

  toggleWindowPortal() {
    this.setState(state => ({
      ...state,
      showWindowPortal: !state.showWindowPortal,
    }));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.showCall && nextProps.isVisible) {
      this.setState({ showCall: true });
    }
    if (this.props.isVisible && !nextProps.isVisible) {
      /* Nucleus should be ending the local stream itself when a call ends,
        but this is extra protection against JS errors that might occur during a call that prevent
         the typical call end action. WEB-3040 */
      this.props.endLocalStream();
      if (!this.props.eatClickTimeout) {
        this.setState({ showCall: false });
      } else {
        setTimeout(() => {
          this.setState({ showCall: false });
        }, this.props.eatClickTimeout);
      }
    }
  }

  render() {
    if (!this.props.isVisible && !this.state.showCall) return null;
    const viewClasses = _compact([
      classes.horzFlexContainer,
      this.props.isMinimized ? classes.minimizedHorzFlexContainer : '',
      this.state.showCall && !this.props.isVisible ? classes.clickEater : ''
    ]).join(' ');
    return (
      <div className={viewClasses}>
        <div className={`${classes.mainContainer}`}>
          <CallView webappCloseWhiteboard={this.props.webappCloseWhiteboard} />
          {this.props.isMinimized ? null : <Drawer />}
        </div>
        {this.props.isMiniPlayerOpen &&
          <Portal toggleMiniPlayer={this.props.toggleMiniPlayer}>
            <MiniPlayerContainer />
            {/* Need this hidden button so that miniPlayer container retains reference for webclientApi obj. */}
            <button className={classes.hiddenButton} onClick={() => window.webClientApi.toggleAudio()} >
            </button>
          </Portal>
        }
        {this.props.isGuestPopoutOpen && <Popout />}
      </div>
    );
  }
}

InCallView.defaultProps = {
  eatClickTimeout: 0
};

InCallView.propTypes = {
  eatClickTimeout: PT.number,
  endLocalStream: PT.func,
  isGuestPopoutOpen: PT.bool,
  isMiniPlayerOpen: PT.bool,
  isMinimized: PT.bool.isRequired,
  isVisible: PT.bool.isRequired,
  toggleMiniPlayer: PT.func.isRequired,
  webappCloseWhiteboard: PT.func
};

export default InCallView;
